(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js');

'use strict';

const {
  useAtom
} = jotai;
const {
  activeExclusionsAtom,
  isNaExcludedAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const {
  SelfExclusion24,
  SetSelfExclusion,
  NationalSelfExclusion,
  Information,
  ActiveExclusions
} = svs.selfExclusion.components;
const SelfExclusionMain = () => {
  const [exclusions] = useAtom(activeExclusionsAtom);
  const [naExcluded] = useAtom(isNaExcludedAtom);
  const hasExclusions = exclusions.length > 0 || naExcluded;
  return React.createElement("main", {
    id: "self-exclusion-overview"
  }, hasExclusions && React.createElement(ActiveExclusions, {
    exclusions: exclusions,
    naExcluded: naExcluded
  }), React.createElement(SelfExclusion24, null), React.createElement(SetSelfExclusion, null), React.createElement(NationalSelfExclusion, null), React.createElement(Information, null));
};
svs.selfExclusion.components.SelfExclusionMain = SelfExclusionMain;

 })(window);